import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import type { ModuleDefinition } from '../../../app/moduleRegistry';
import { isFeatureEnabled } from '../../../config/featureFlags';
import CorporateProfilePage from './pages/CorporateProfilePage';

/** Self-service "Firma Profilim" (legacy `CorporateProfile`) — visible to any corporate
 *  user, not just admins. Gated only on the Kurumsal feature flag. */
export const corporateProfileModule: ModuleDefinition = {
  routes: [{ path: 'corporate/profile', element: <CorporateProfilePage /> }],
  menuItems: [
    {
      label: 'Firma Profilim',
      path: 'corporate/profile',
      icon: <BadgeOutlinedIcon />,
      group: 'Kurumsal',
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
  ],
};
